<template>
  <el-dialog
    title=""
    :visible.sync="drawer"
    :direction="direction"
    :before-close="handleClose"
    append-to-body
    size="960px"
    :wrapperClosable="false"
    :close-on-press-escape="false"
  >
    <div class="drawer-content">
      <div class="preview">
        <div class="title">预览</div>
        <div class="info">
          <div class="school">
            <div class="logo" v-if="schoolInfo.logUrl">
              <img
                class="img"
                :src="$store.state.config.fileUrl + schoolInfo.logUrl"
                alt=""
              />
            </div>
            <div class="name">{{ schoolInfo.schoolName }}</div>
          </div>
          <div class="card-title">{{ infoForm.headerName }}</div>
          <div class="li li-1">
            <div class="li-left">岗位</div>
            <div class="li-right">{{ infoForm.post }}</div>
          </div>
          <div class="li li-2">
            <div class="li-left">
              <div>易发生</div>
              <div>事故类型</div>
            </div>
            <div class="li-right">{{ infoForm.typesAccidents }}</div>
          </div>
          <div class="li li-3">
            <div class="li-left">主要风险因素</div>
            <div class="li-right" style="white-space: pre-line;">
              {{ infoForm.mainRiskFactors }}
            </div>
          </div>
          <div class="li li-4">
            <div class="li-left">管控措施</div>
            <div class="li-right" style="white-space: pre-line;">
              {{ infoForm.controlMeasures }}
            </div>
          </div>
          <div class="li li-5">
            <div class="li-left">应急措施</div>
            <div class="li-right" style="white-space: pre-line;">
              {{ infoForm.emergencyMeasures }}
            </div>
          </div>
          <div class="li li-6">
            <div class="li-left">应急电话</div>
            <div class="li-right">{{ infoForm.emergencyCall }}</div>
          </div>
          <div class="li warn-icon">
            <img
              class="img"
              v-show="checked1"
              src="@/assets/img/noticeTemplates/new/1.jpg"
              alt=""
            />
            <img
              class="img"
              v-show="checked2"
              src="@/assets/img/noticeTemplates/new/2.png"
              alt=""
            />
            <img
              class="img"
              v-show="checked3"
              src="@/assets/img/noticeTemplates/new/3.png"
              alt=""
            />
            <img
              class="img"
              v-show="checked4"
              src="@/assets/img/noticeTemplates/new/4.png"
              alt=""
            />
            <img
              class="img"
              v-show="checked5"
              src="@/assets/img/noticeTemplates/new/5.png"
              alt=""
            />
            <img
              class="img"
              v-show="checked6"
              src="@/assets/img/noticeTemplates/new/6.png"
              alt=""
            />
            <img
              class="img"
              v-show="checked7"
              src="@/assets/img/noticeTemplates/new/7.png"
              alt=""
            />
            <img
              class="img"
              v-show="checked8"
              src="@/assets/img/noticeTemplates/new/8.png"
              alt=""
            />
            <img
              class="img"
              v-show="checked9"
              src="@/assets/img/noticeTemplates/new/9.png"
              alt=""
            />
            <img
              class="img"
              v-show="checked10"
              src="@/assets/img/noticeTemplates/new/10.png"
              alt=""
            />
            <img
              class="img"
              v-show="checked11"
              src="@/assets/img/noticeTemplates/new/11.png"
              alt=""
            />
            <img
              class="img"
              v-show="checked12"
              src="@/assets/img/noticeTemplates/new/12.png"
              alt=""
            />
            <img
              class="img"
              v-show="checked13"
              src="@/assets/img/noticeTemplates/new/13.png"
              alt=""
            />
            <img
              class="img"
              v-show="checked14"
              src="@/assets/img/noticeTemplates/new/14.png"
              alt=""
            />
            <img
              class="img"
              v-show="checked15"
              src="@/assets/img/noticeTemplates/new/15.png"
              alt=""
            />
            <img
              class="img"
              v-show="checked15"
              src="@/assets/img/noticeTemplates/new/16.png"
              alt=""
            />
            <img
              class="img"
              v-show="checked17"
              src="@/assets/img/noticeTemplates/new/17.png"
              alt=""
            />
            <img
              class="img"
              v-show="checked18"
              src="@/assets/img/noticeTemplates/new/18.png"
              alt=""
            />
            <img
              class="img"
              v-show="checked19"
              src="@/assets/img/noticeTemplates/new/19.png"
              alt=""
            />
            <img
              class="img"
              v-show="checked20"
              src="@/assets/img/noticeTemplates/new/20.png"
              alt=""
            />
            <img
              class="img"
              v-show="checked21"
              src="@/assets/img/noticeTemplates/new/21.png"
              alt=""
            />
            <img
              class="img"
              v-show="checked22"
              src="@/assets/img/noticeTemplates/new/22.png"
              alt=""
            />
            <img
              class="img"
              v-show="checked23"
              src="@/assets/img/noticeTemplates/new/23.png"
              alt=""
            />
            <img
              class="img"
              v-show="checked24"
              src="@/assets/img/noticeTemplates/new/24.png"
              alt=""
            />
            <img
              class="img"
              v-show="checked25"
              src="@/assets/img/noticeTemplates/new/25.png"
              alt=""
            />
            <img
              class="img"
              v-show="checked26"
              src="@/assets/img/noticeTemplates/new/26.png"
              alt=""
            />
            <img
              class="img"
              v-show="checked27"
              src="@/assets/img/noticeTemplates/new/27.png"
              alt=""
            />
            <img
              class="img"
              v-show="checked28"
              src="@/assets/img/noticeTemplates/new/28.png"
              alt=""
            />
            <img
              class="img"
              v-show="checked29"
              src="@/assets/img/noticeTemplates/new/29.png"
              alt=""
            />
            <img
              class="img"
              v-show="checked30"
              src="@/assets/img/noticeTemplates/new/30.png"
              alt=""
            />
            <img
              class="img"
              v-show="checked31"
              src="@/assets/img/noticeTemplates/new/31.png"
              alt=""
            />
            <img
              class="img"
              v-show="checked32"
              src="@/assets/img/noticeTemplates/new/32.png"
              alt=""
            />
            <img
              class="img"
              v-show="checked33"
              src="@/assets/img/noticeTemplates/new/33.png"
              alt=""
            />
            <img
              class="img"
              v-show="checked34"
              src="@/assets/img/noticeTemplates/new/34.png"
              alt=""
            />
            <img
              class="img"
              v-show="checked35"
              src="@/assets/img/noticeTemplates/new/35.png"
              alt=""
            />
            <img
              class="img"
              v-show="checked36"
              src="@/assets/img/noticeTemplates/new/36.png"
              alt=""
            />
          </div>
        </div>
      </div>
      <div class="edit">
        <div class="title">编辑</div>
        <el-form
          class="edit-form"
          ref="form"
          :model="infoForm"
          label-width="96px"
        >
          <div class="school">
            <div class="logo" v-if="schoolInfo.logUrl">
              <img
                class="img"
                :src="$store.state.config.fileUrl + schoolInfo.logUrl"
                alt=""
              />
            </div>
            <div class="name">{{ schoolInfo.schoolName }}</div>
          </div>
          <div class="card-title">
            <el-input
              class="input"
              v-model.trim="infoForm.headerName"
              placeholder="请添加模板名称"
            ></el-input>
          </div>
          <div class="li li-1">
            <div class="li-left">岗位</div>
            <div class="li-right">
              <el-input
                v-if="operateType == 0"
                class="input"
                v-model.trim="infoForm.post"
                placeholder="请添加岗位名称"
              ></el-input>
              <el-select
                v-if="operateType == 1"
                class="select"
                size="mini"
                v-model="post"
                placeholder="请选择岗位"
                @change="sel"
              >
                <el-option
                  v-for="item in defaultList"
                  :label="item.announcementDataName"
                  :value="item.announcementDataId"
                  :key="item.announcementDataId"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="li li-2">
            <div class="li-left">
              <div>易发生</div>
              <div>事故类型</div>
            </div>
            <div class="li-right">
              <el-input
                class="input"
                v-model.trim="infoForm.typesAccidents"
                placeholder="请添加易发生事故类型"
              ></el-input>
            </div>
          </div>
          <div class="li li-3">
            <div class="li-left">主要风险因素</div>
            <div class="li-right">
              <el-input
                class="input"
                type="textarea"
                v-model.trim="infoForm.mainRiskFactors"
                placeholder="请添加主要风险因素"
                resize="none"
              ></el-input>
            </div>
          </div>
          <div class="li li-4">
            <div class="li-left">管控措施</div>
            <div class="li-right">
              <el-input
                class="input"
                type="textarea"
                v-model.trim="infoForm.controlMeasures"
                placeholder="请添加管控措施"
                resize="none"
              ></el-input>
            </div>
          </div>
          <div class="li li-5">
            <div class="li-left">应急措施</div>
            <div class="li-right">
              <el-input
                class="input"
                type="textarea"
                v-model.trim="infoForm.emergencyMeasures"
                placeholder="请添加应急措施"
                resize="none"
              ></el-input>
            </div>
          </div>
          <div class="li li-6">
            <div class="li-left">应急电话</div>
            <div class="li-right">
              <el-input
                class="input"
                v-model.trim="infoForm.emergencyCall"
                placeholder="请添加应急电话"
              ></el-input>
            </div>
          </div>
          <div class="li warn-sel">
            <el-checkbox v-model="checked1">须测体温</el-checkbox>
            <el-checkbox v-model="checked2">穿防护服</el-checkbox>
            <el-checkbox v-model="checked3">穿防护鞋</el-checkbox>
            <el-checkbox v-model="checked4">戴护口罩</el-checkbox>
            <el-checkbox v-model="checked5">戴护手套</el-checkbox>
            <el-checkbox v-model="checked6">必须加锁</el-checkbox>
            <el-checkbox v-model="checked7">必须接地</el-checkbox>
            <el-checkbox v-model="checked8">戴安全帽</el-checkbox>
            <el-checkbox v-model="checked9">防尘口罩</el-checkbox>
            <el-checkbox v-model="checked10">戴护眼镜</el-checkbox>
            <el-checkbox v-model="checked11">必须洗手</el-checkbox>
            <el-checkbox v-model="checked12">访客登记</el-checkbox>
            <el-checkbox v-model="checked13">当心车辆</el-checkbox>
            <el-checkbox v-model="checked14">当心触电</el-checkbox>
            <el-checkbox v-model="checked15">当心腐蚀</el-checkbox>
            <el-checkbox v-model="checked16">当心滑倒</el-checkbox>
            <el-checkbox v-model="checked17">当心火灾</el-checkbox>
            <el-checkbox v-model="checked18">当心坑洞</el-checkbox>
            <el-checkbox v-model="checked19">当心落水</el-checkbox>
            <el-checkbox v-model="checked20">当心落物</el-checkbox>
            <el-checkbox v-model="checked21">当心烫伤</el-checkbox>
            <el-checkbox v-model="checked22">当心中毒</el-checkbox>
            <el-checkbox v-model="checked23">注意坠落</el-checkbox>
            <el-checkbox v-model="checked24">注意安全</el-checkbox>
            <el-checkbox v-model="checked25">禁止触摸</el-checkbox>
            <el-checkbox v-model="checked26">禁易燃物</el-checkbox>
            <el-checkbox v-model="checked27">禁止靠近</el-checkbox>
            <el-checkbox v-model="checked28">禁止攀登</el-checkbox>
            <el-checkbox v-model="checked29">禁止伸入</el-checkbox>
            <el-checkbox v-model="checked30">禁止停留</el-checkbox>
            <el-checkbox v-model="checked31">禁止吸烟</el-checkbox>
            <el-checkbox v-model="checked32">易燃易爆</el-checkbox>
            <el-checkbox v-model="checked33">禁止有毒</el-checkbox>
            <el-checkbox v-model="checked34">禁止武器</el-checkbox>
            <el-checkbox v-model="checked35">禁止烟火</el-checkbox>
            <el-checkbox v-model="checked36">禁止依靠</el-checkbox>
          </div>
        </el-form>
        <div class="button-box">
          <el-button type="primary" size="small" @click="updateTemplate"
            >确定</el-button
          >
          <el-button size="small" style="margin-left: 20px" @click="handleClose"
            >返回</el-button
          >
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "RiskNoticeTemplateOperate",
  components: {},
  props: {
    operateResize: {
      type: Number,
      default: {
        return: 0
      }
    },
    detail: {
      type: Object,
      default: () => {
        return {};
      }
    },
    operateType: {
      type: Number,
      default: {
        return: 0
      }
    }
  },
  data() {
    return {
      drawer: false,
      direction: "ltr",
      schoolName: this.$store.state.schoolInfo.schoolName,
      infoForm: {},
      checked1: false,
      checked2: false,
      checked3: false,
      checked4: false,
      checked5: false,
      checked6: false,
      checked7: false,
      checked8: false,
      checked9: false,
      checked10: false,
      checked11: false,
      checked12: false,
      checked13: false,
      checked14: false,
      checked15: false,
      checked16: false,
      checked17: false,
      checked18: false,
      checked19: false,
      checked20: false,
      checked21: false,
      checked22: false,
      checked23: false,
      checked24: false,
      checked25: false,
      checked26: false,
      checked27: false,
      checked28: false,
      checked29: false,
      checked30: false,
      checked31: false,
      checked32: false,
      checked33: false,
      checked34: false,
      checked35: false,
      checked36: false,
      warnString: "",
      post: "",
      defaultList: []
    };
  },
  created() {},
  mounted() {},
  watch: {
    operateResize: function(newVal, oldVal) {
      if (newVal) {
        this.infoForm = this.detail;
        this.drawer = true;
        this.modify(this.infoForm.warningIcon);
        this.post = this.infoForm.post;
        this.getDefaultList(this.infoForm.templateType);
        // console.log(this.infoForm);
        // console.log(this.$store.state.schoolInfo);
      }
    }
  },
  computed: {
    schoolInfo() {
      return this.$store.state.schoolInfo;
    }
  },
  methods: {
    handleClose() {
      this.clearData();
      this.drawer = false;
    },
    sel(val) {
      // console.log(val)
      // console.log(this.defaultList)
      let item = this.defaultList.find((element) => {
        return element.announcementDataId == val;
      });
      // console.log(item)
      this.infoForm.post = item.announcementDataName;
      this.infoForm.mainRiskFactors = item.riskFactor;
      this.infoForm.typesAccidents = item.typeAccident;
      this.infoForm.controlMeasures = item.controlMeasures;
      this.infoForm.emergencyMeasures = item.emergencyMeasures;
    },
    clearData() {
      this.resizeCheck();
      this.post = "";
    },
    resizeCheck() {
      this.checked1 = false;
      this.checked2 = false;
      this.checked3 = false;
      this.checked4 = false;
      this.checked5 = false;
      this.checked6 = false;
      this.checked7 = false;
      this.checked8 = false;
      this.checked9 = false;
      this.checked10 = false;
      this.checked11 = false;
      this.checked12 = false;
      this.checked13 = false;
      this.checked14 = false;
      this.checked15 = false;
      this.checked16 = false;
      this.checked17 = false;
      this.checked18 = false;
      this.checked19 = false;
      this.checked20 = false;
      this.checked21 = false;
      this.checked22 = false;
      this.checked23 = false;
      this.checked24 = false;
      this.checked25 = false;
      this.checked26 = false;
      this.checked27 = false;
      this.checked28 = false;
      this.checked29 = false;
      this.checked30 = false;
      this.checked31 = false;
      this.checked32 = false;
      this.checked33 = false;
      this.checked34 = false;
      this.checked35 = false;
      this.checked36 = false;
    },
    modify(str) {
      let arr = this.strToArray(str);
      // console.log(arr);
      if (this.check("1", arr)) {
        this.checked1 = true;
      }
      if (this.check("2", arr)) {
        this.checked2 = true;
      }
      if (this.check("3", arr)) {
        this.checked3 = true;
      }
      if (this.check("4", arr)) {
        this.checked4 = true;
      }
      if (this.check("5", arr)) {
        this.checked5 = true;
      }
      if (this.check("6", arr)) {
        this.checked6 = true;
      }
      if (this.check("7", arr)) {
        this.checked7 = true;
      }
      if (this.check("8", arr)) {
        this.checked8 = true;
      }
      if (this.check("9", arr)) {
        this.checked9 = true;
      }
      if (this.check("10", arr)) {
        this.checked10 = true;
      }
      if (this.check("11", arr)) {
        this.checked11 = true;
      }
      if (this.check("12", arr)) {
        this.checked12 = true;
      }
      if (this.check("13", arr)) {
        this.checked13 = true;
      }
      if (this.check("14", arr)) {
        this.checked14 = true;
      }
      if (this.check("15", arr)) {
        this.checked15 = true;
      }
      if (this.check("16", arr)) {
        this.checked16 = true;
      }
      if (this.check("17", arr)) {
        this.checked17 = true;
      }
      if (this.check("18", arr)) {
        this.checked18 = true;
      }
      if (this.check("19", arr)) {
        this.checked19 = true;
      }
      if (this.check("20", arr)) {
        this.checked20 = true;
      }
      if (this.check("21", arr)) {
        this.checked21 = true;
      }
      if (this.check("22", arr)) {
        this.checked22 = true;
      }
      if (this.check("23", arr)) {
        this.checked23 = true;
      }
      if (this.check("24", arr)) {
        this.checked24 = true;
      }
      if (this.check("25", arr)) {
        this.checked25 = true;
      }
      if (this.check("26", arr)) {
        this.checked26 = true;
      }
      if (this.check("27", arr)) {
        this.checked27 = true;
      }
      if (this.check("28", arr)) {
        this.checked28 = true;
      }
      if (this.check("29", arr)) {
        this.checked29 = true;
      }
      if (this.check("30", arr)) {
        this.checked30 = true;
      }
      if (this.check("31", arr)) {
        this.checked31 = true;
      }
      if (this.check("32", arr)) {
        this.checked32 = true;
      }
      if (this.check("33", arr)) {
        this.checked33 = true;
      }
      if (this.check("34", arr)) {
        this.checked34 = true;
      }
      if (this.check("35", arr)) {
        this.checked35 = true;
      }
      if (this.check("36", arr)) {
        this.checked36 = true;
      }
    },
    strToArray(str) {
      // console.log(str)

      var arr = str.split(",");
      // console.log(arr);
      return arr;
    },
    // 检查是否在数组中
    check(num, arr) {
      if (arr.includes(num)) {
        return true;
      } else {
        return false;
      }
    },
    getwarnString() {
      let str = "";
      if (this.checked1) {
        str = str + "1,";
      }
      if (this.checked2) {
        str = str + "2,";
      }
      if (this.checked3) {
        str = str + "3,";
      }
      if (this.checked4) {
        str = str + "4,";
      }
      if (this.checked5) {
        str = str + "5,";
      }
      if (this.checked6) {
        str = str + "6,";
      }
      if (this.checked7) {
        str = str + "7,";
      }
      if (this.checked8) {
        str = str + "8,";
      }
      if (this.checked9) {
        str = str + "9,";
      }
      if (this.checked10) {
        str = str + "10,";
      }
      if (this.checked11) {
        str = str + "11,";
      }
      if (this.checked12) {
        str = str + "12,";
      }
      if (this.checked13) {
        str = str + "13,";
      }
      if (this.checked14) {
        str = str + "14";
      }
      if (this.checked15) {
        str = str + "15,";
      }
      if (this.checked16) {
        str = str + "16,";
      }
      if (this.checked17) {
        str = str + "17,";
      }
      if (this.checked18) {
        str = str + "18,";
      }
      if (this.checked19) {
        str = str + "19,";
      }
      if (this.checked20) {
        str = str + "20,";
      }
      if (this.checked21) {
        str = str + "21,";
      }
      if (this.checked22) {
        str = str + "22,";
      }
      if (this.checked23) {
        str = str + "23,";
      }
      if (this.checked24) {
        str = str + "24,";
      }
      if (this.checked25) {
        str = str + "25,";
      }
      if (this.checked26) {
        str = str + "26,";
      }
      if (this.checked27) {
        str = str + "27,";
      }
      if (this.checked28) {
        str = str + "28,";
      }
      if (this.checked29) {
        str = str + "29,";
      }
      if (this.checked30) {
        str = str + "30,";
      }
      if (this.checked31) {
        str = str + "31,";
      }
      if (this.checked32) {
        str = str + "32,";
      }
      if (this.checked33) {
        str = str + "33,";
      }
      if (this.checked34) {
        str = str + "34,";
      }
      if (this.checked35) {
        str = str + "35,";
      }
      if (this.checked36) {
        str = str + "36,";
      }
      this.warnString = str;
    },
    // 获取告知模板列表
    async updateTemplate() {
      this.getwarnString();
      // console.log(this.warnString);
      // return;
      let req = {
        id: this.infoForm.id,
        backgroundImage: this.infoForm.backgroundImage,
        controlMeasures: this.infoForm.controlMeasures,
        emergencyCall: this.infoForm.emergencyCall,
        emergencyMeasures: this.infoForm.emergencyMeasures,
        headerName: this.infoForm.headerName,
        mainRiskFactors: this.infoForm.mainRiskFactors,
        post: this.infoForm.post,
        responsible: this.infoForm.responsible,
        typesAccidents: this.infoForm.typesAccidents,
        warningIcon: this.warnString
      };
      // console.log(req);
      // return;
      let res = await this.$Http.updateNoticeTemplate(req);
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: "编辑成功!"
        });
        this.handleClose();
        this.$emit("getList");
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 获取预设数据
    async getDefaultList(id) {
      let req = {
        announcementDataType: id
      };
      let res = await this.$Http.getNoticeTemplateDefault(req);
      if (res.code == 200) {
        this.defaultList = res.data || [];
      } else if (res.code == 101) {
        this.defaultList = [];
      } else {
        this.$message({
          message: res.messsage,
          type: "error"
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.drawer-content {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  .preview {
    margin-right: 20px;
    width: 46%;
    // background: chartreuse;
    .title {
      font-size: 16px;
      padding-bottom: 30px;
    }
    .info {
      width: 402px;
      height: 580px;
      background-image: url("~@/assets/img/noticeTemplates/bg-1.png");
      background-position: center center;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      .school {
        padding: 8px 20px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .logo {
          width: 45px;
          height: 45px;
          border-radius: 50%;
          .img {
            display: block;
            width: 100%;
            height: 100%;
            border-radius: 50%;
          }
        }
        .name {
          height: 45px;
          line-height: 45px;
          padding-left: 16px;
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 600;
          color: #1c1c1c;
        }
      }
      .card-title {
        margin: 26px auto 0 auto;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 356px;
        height: 32px;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #1c1c1c;
        word-break: break-all;
        overflow: scroll;
      }
      .li {
        padding: 0 20px;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        &.li-1 {
          line-height: 1.5;
          .li-left {
            width: 80px;
            font-size: 14px;
            font-weight: 600;
            text-align: center;
          }
          .li-right {
            padding-top: 1px;
            width: 280px;
            height: 20px;
            display: flex;
            justify-content: center;
            align-items: center;
            word-break: break-all;
            overflow: scroll;
          }
        }
        &.li-2 {
          height: 42px;
          line-height: 1.2;
          .li-right {
            width: 280px;
            height: 42px;
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }
        &.li-3 {
          padding-top: 3px;
          height: 82px;
          line-height: 1.2;
          .li-left {
            width: 80px;
          }
          .li-right {
            width: 280px;
            height: 76px;
            word-break: break-all;
            overflow: scroll;
          }
        }
        &.li-4 {
          padding-top: 2px;
          height: 80px;
          line-height: 1.2;
          .li-right {
            padding-left: 2px;
            padding-right: 2px;
            width: 280px;
            height: 76px;
            word-break: break-all;
            overflow: scroll;
          }
        }
        &.li-5 {
          height: 78px;
          line-height: 1.2;
          .li-right {
            width: 280px;
            height: 76px;
            word-break: break-all;
            overflow: scroll;
          }
        }
        &.li-6 {
          height: 40px;
          line-height: 1.2;
          .li-right {
            width: 280px;
            height: 38px;
            display: flex;
            justify-content: center;
            align-items: center;
            word-break: break-all;
            overflow: scroll;
          }
        }
        .li-left {
          margin-left: -5px;
          width: 80px;
          height: 100%;
          font-size: 12px;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
        }
        .li-right {
          padding-left: 2px;
          padding-right: 2px;
          width: 280px;
          display: flex;
          align-items: center;
        }
      }
      .warn-icon {
        width: 402px;
        height: 100px;
        display: flex;
        justify-content: center;
        align-items: center;
        .img {
          margin: 0 2px;
          width: 40.6px;
          height: 50px;
        }
      }
    }
  }
  .edit {
    width: 46%;
    // background: chocolate;
    .title {
      font-size: 16px;
      padding-bottom: 30px;
    }
    /deep/ .edit-form {
      width: 402px;
      height: 580px;
      background-image: url("~@/assets/img/noticeTemplates/bg-1.png");
      background-position: center center;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      .school {
        padding: 8px 20px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .logo {
          width: 45px;
          height: 45px;
          border-radius: 50%;
          .img {
            display: block;
            width: 100%;
            height: 100%;
            border-radius: 50%;
          }
        }
        .name {
          height: 45px;
          line-height: 45px;
          padding-left: 16px;
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 600;
          color: #1c1c1c;
        }
      }

      .card-title {
        margin-top: 26px;
        height: 30px;
        text-align: center;
        .input {
          width: 100%;
          height: 100%;
          padding: 0 50px;
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 600;
          color: #1c1c1c;
          .el-input__inner {
            width: 100%;
            height: 100%;
            text-align: center;
          }
        }
      }
      .li {
        padding: 0 20px;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        &.li-1 {
          padding-top: 2px;
          line-height: 1.5;
          .li-left {
            width: 80px;
            font-size: 14px;
            font-weight: 600;
            text-align: center;
          }
          .li-right {
            .input {
              margin-top: 1px;
              width: 280px;
              height: 20px;
              font-size: 12px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 600;
              color: #1c1c1c;
              .el-input__inner {
                width: 100%;
                height: 100%;
                text-align: center;
              }
            }
            .select {
              .el-input__inner {
                height: 24px;
              }
            }
          }
        }
        &.li-2 {
          margin-top: -2px;
          height: 40px;
          line-height: 1.2;
          .li-right {
            .input {
              margin-top: 2px;
              width: 280px;
              height: 36px;
              font-size: 12px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #1c1c1c;
              .el-input__inner {
                width: 100%;
                height: 100%;
              }
            }
          }
        }
        &.li-3 {
          height: 78px;
          line-height: 1.2;
          .li-left {
            width: 80px;
          }
          .li-right {
            .input {
              margin-top: 2px;
              width: 280px;
              height: 78px;
              font-size: 12px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #1c1c1c;
              .el-textarea__inner {
                width: 100%;
                height: 100%;
              }
            }
          }
        }
        &.li-4 {
          height: 84px;
          line-height: 1.2;
          .li-right {
            .input {
              margin-top: 4px;
              width: 280px;
              height: 76px;
              font-size: 12px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #1c1c1c;
              .el-textarea__inner {
                width: 100%;
                height: 100%;
              }
            }
          }
        }
        &.li-5 {
          height: 78px;
          line-height: 1.2;
          .li-right {
            .input {
              margin-top: 1px;
              width: 280px;
              height: 76px;
              font-size: 12px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #1c1c1c;
              .el-textarea__inner {
                width: 100%;
                height: 100%;
              }
            }
          }
        }
        &.li-6 {
          height: 44px;
          line-height: 1.2;
          .li-right {
            .input {
              margin-top: 1px;
              width: 280px;
              height: 40px;
              font-size: 12px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #1c1c1c;
              .el-input__inner {
                width: 100%;
                height: 100%;
              }
            }
          }
        }
        &.warn-sel {
          max-height: 96px;
          overflow-y: scroll;
          padding: 2px 10px 0px 24px;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          flex-wrap: wrap;
          .el-checkbox {
            margin-right: 10px;
          }
        }
        .li-left {
          margin-left: -5px;
          width: 80px;
          height: 100%;
          font-size: 12px;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
        }
        .li-right {
          .input {
            width: 280px;
            height: 20px;
            font-size: 12px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #1c1c1c;
            .el-input__inner {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }
    .button-box {
      margin-top: 20px;
    }
  }
}
</style>
